// Project Sentinel - Main Entry Point
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@/contexts/theme-context'
import { CustomerProvider } from '@/contexts/customer-context'
import { TimePeriodProvider } from '@/contexts/time-period-context'
import { DockProvider } from '@/contexts/dock-context'
import { TooltipProvider } from '@/components/ui/tooltip'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ThemeProvider defaultTheme="dark">
        <CustomerProvider>
          <TimePeriodProvider>
            <DockProvider>
              <TooltipProvider>
                <App />
              </TooltipProvider>
            </DockProvider>
          </TimePeriodProvider>
        </CustomerProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
)
